export const InterpolationType = {
  NEAREST: 0,
  LINEAR: 1,
};

export default {
  InterpolationType,
};
